import { jsx as _jsx } from "react/jsx-runtime";
import { CardsWrapper } from "@sprout/client-components/dist/Cards";
import { useNavigationList } from "@sprout/list-navigation";
import { useMemo } from "react";
import { Droppable } from "react-beautiful-dnd";
import { PostPageTodo } from "../PostPageTodo";
const PostPageTodoListTodosCompleted = (props)=>{
    const { parentId , todos , disabled , todoSingularAction , todoSupportedActions ,  } = props;
    const { Provider , navProps  } = useNavigationList(`PostPageTodoListTodosCompleted|${parentId}`, useMemo(()=>({
            actions: todoSupportedActions,
            performSingularAction: todoSingularAction
        }), [
        todoSingularAction,
        todoSupportedActions
    ]));
    /**
   * Why is a droppable needed here even though it is not technically needed?
   *
   * Well to simplify the code, so we do not need to manually wrap
   * `PostPageTodoWithListNavigation` conditionally.
   *
   * This causes the component to look similar to
   * `TopicPageViewsTopicListPostWithListNavigation`
   */ return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(Droppable, {
            droppableId: "PostPageTodoListTodosCompleted-unused",
            isDropDisabled: true,
            isCombineEnabled: false,
            children: (dropProvided)=>/*#__PURE__*/ _jsx(CardsWrapper, {
                    ref: (element)=>{
                        dropProvided.innerRef(element);
                        navProps.ref.current = element;
                    },
                    children: todos.map((todo, index)=>{
                        return /*#__PURE__*/ _jsx(PostPageTodo, {
                            disabled: disabled,
                            todo: todo,
                            index: index
                        }, todo.nodeId);
                    })
                })
        })
    });
};
export default PostPageTodoListTodosCompleted;
